import React from 'react';
import Tab from 'Components/DesignSystem/Tab/Tab';
import { TabItem } from 'types/DesignSystem/Tab';

type IterationTabsProps = {
    activeTab: string;
    setActiveTab: (tab: 'matchingConditions' | 'attributeSorting') => void;
};

/**
 * The builder's two-tab strip on the DS `Tab` (2026-09-08) — was two hand-rolled
 * buttons with `tw-border-blue-950` / `tw-text-gray-600` literals. Same per-tab
 * testids, same `setActiveTab` values.
 */
const IterationTabs: React.FC<IterationTabsProps> = ({ activeTab, setActiveTab }) => {
    const tabs: TabItem[] = [
        { id: 'matchingConditions', label: 'Matching Conditions', 'data-testid': 'matching-conditions-tab' },
        { id: 'attributeSorting', label: 'Attributes Sorting', 'data-testid': 'attributes-sorting-tab' },
    ];

    return (
        <Tab
            tabs={tabs}
            activeTabId={activeTab}
            onChange={(tabId) => setActiveTab(tabId as 'matchingConditions' | 'attributeSorting')}
            className="tw-ps-6"
            data-testid="iteration-tabs"
        />
    );
};

export default IterationTabs;
